import { API_MAP, agent } from 'helpers';
class ConfirmationService {
  static changeCoproducerStatus(values: any) {
    return agent.post(`${API_MAP.moderateCoproducers}`, values);
  }
}
export default ConfirmationService;
